import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@workspace/ui/components/dialog";
import { useModal } from "../providers/modal-provider";
import { discountImages, modalIds } from "./constants";
import Image from "next/image";
import { CTAButton } from "../cta-button";
import { useApp } from "../providers/app-provider";
import { EventNames } from "@/lib/utils/analytics";
import { usePathname } from "next/navigation";

export const AndroidAnnouncementModal = () => {
  const { handleCloseModal, modalId, handleOpenModal } = useModal();
  const isOpen = modalId === modalIds.androidAnnouncement;
  const { workflow } = useApp();
  const pathname = usePathname();

  // Hiding announcement modal for android
  // useEffect(() => {
  //   let timerId: NodeJS.Timeout;
  //   const cookie = getCookie("showed_android_announcement_popup");
  //   if (
  //     cookie !== "valid" &&
  //     modalId === "" &&
  //     workflow === "ng" &&
  //     pathname === "/"
  //   ) {
  //     timerId = setTimeout(() => {
  //       handleOpenModal(modalIds.androidAnnouncement);
  //       sendEvent(EventNames.ANNOUNCEMENT_POPUP_VIEWED);
  //       setCookie("showed_android_announcement_popup", "valid", 7);
  //     }, 7000);
  //   }
  //   return () => clearTimeout(timerId);
  // }, [modalId, pathname]);

  return (
    <Dialog open={isOpen} onOpenChange={handleCloseModal}>
      <DialogContent className="max-w-[560px] border-0 mx-auto p-0 gap-0 fixed top-auto bottom-0 left-0 right-0 translate-y-0 translate-x-0 md:fixed md:top-[50%] md:left-[50%] md:translate-x-[-50%] md:translate-y-[-50%] md:bottom-auto md:right-auto md:overflow-hidden">
        <div className="h-[240px] md:h-[260px] w-full relative">
          <Image
            src={discountImages[workflow || "ng"]}
            alt="android-kit"
            className="h-[260px] w-full object-cover"
            fill
          />
        </div>
        <div className="px-5 py-8 gap-8 flex flex-col">
          <div className="flex flex-col gap-4 text-center">
            <DialogHeader
              className="flex flex-col gap-4"
              id="announcement-header"
              data-testid="announcement-header"
            >
              <div className="flex flex-col gap-2 items-center">
                <DialogTitle
                  className="text-center max-w-[340px] text-[28px] font-medium md:!title-32 leading-[1.2]"
                  id="announcement-title"
                  data-testid="announcement-title"
                >
                  Wait is over! Inito is now available for Android
                </DialogTitle>
                <DialogDescription
                  className="md:!body-16 text-center max-w-[396px] text-sm leading-[1.5]"
                  id="announcement-description"
                  data-testid="announcement-description"
                >
                  Track your hormones like never before. Smarter. Sleeker. Built
                  for precision.
                </DialogDescription>
              </div>
            </DialogHeader>
          </div>
          <DialogFooter
            id="announcement-footer"
            data-testid="announcement-footer"
          >
            <div className="w-full gap-4 flex flex-col">
              <CTAButton
                text="Get Inito Fertility Tracker"
                textClassName="w-full !body-14 !md:body-17 uppercase"
                testId="announcement-cta"
                handleCTAClick={handleCloseModal}
                className="md:w-full"
                containerClassName="w-full md:max-w-full"
                type="buy_now"
                eventName={
                  EventNames.ANDROID_ANNOUNCEMENT_POPUP_GET_INITO_CLICKED
                }
              />
              <CTAButton
                text="Know more"
                textClassName="w-full !body-14 !md:body-17 uppercase"
                testId="know-more-cta"
                handleCTAClick={handleCloseModal}
                className="md:w-full"
                containerClassName="w-full md:max-w-full"
                variant="outline"
                type="pitch"
                eventName={
                  EventNames.ANDROID_ANNOUNCEMENT_POPUP_KNOW_MORE_CLICKED
                }
              />
            </div>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
};
